import axios from "axios";

import { successHandling } from "../helpers/successHandling";

export const updateFileNameAPI = async (
  storedValue,
  value,
  id,
  setStoredValue,
  setValue,
  t,
  successfulText
) => {
  try {
    await axios({
      url: `/api/v2/drive/file/update-name`,
      method: "PUT",
      data: {
        id: id,
        name: value
      }
    });

    successHandling(t, successfulText);
    setStoredValue(value);
  } catch (error) {
    setValue(storedValue);
  }
};
